export default string => (string && string[0]) ? `${string[0].toUpperCase()}${string.slice(1)}` : ''
